export default "__VITE_ASSET__DILANpfC__"